import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "2.5", fill: "white", stroke: "#9C9C9C" })), 'CheckboxOff');
